import { DndContext, DragOverlay, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { Col, Flex, Row, Typography } from 'antd';
import { useContext, useState } from 'react';
import Droppable from '../utils/drag-drop/Droppable';
import EmptyLibrary from './EmptyLibrary';
import { LibraryContext } from './context-provider';
import FileCard from './file-card';
import FolderCard from './folder-card';
import LibraryTable from './library-table';
const { Text } = Typography;

export default function LibraryList({ library }) {
   const { view } = useContext(LibraryContext);
   const [activeId, setActiveId] = useState(null);
   const sensors = useSensors(
      useSensor(PointerSensor, {
         activationConstraint: {
            distance: 5,
         },
      })
   );

   function handleDragEnd(event) {
      const { active, over } = event;

      // if active draggable is a file and over droppable is a folder, update file
      if (active?.data?.current?.type === 'file') {
         library.moveFile(active?.data?.current?._id, over?.id);
      }

      // if active draggable is a folder and over droppable is a folder, update folder
      if (active?.data?.current?.type === 'folder' && over?.id !== active?.data?.current?._id) {
         library.moveFolder(active?.data?.current?._id, over?.id);
      }

      setActiveId(null);
   }

   function handleDragStart(event) {
      const { active } = event;
      setActiveId(active.id);
   }

   if (library?.isLoading) return <div>Loading...</div>;
   if (library?.isError) return <div>Error</div>;
   if (!library?.data || library?.data?.length === 0) return <div>No data</div>;

   // return EmptyLibrary if library is empty
   if (library?.data?.folders?.length === 0 && library?.data?.files?.length === 0) {
      return <EmptyLibrary />;
   }

   // Render based on view
   if (view === 'list')
      return (
         <DndContext onDragEnd={handleDragEnd} onDragStart={handleDragStart} sensors={sensors}>
            <LibraryTable library={library} />
         </DndContext>
      );

   return (
      <>
         <DndContext onDragEnd={handleDragEnd} onDragStart={handleDragStart} sensors={sensors}>
            <Row gutter={[32, 32]}>
               {/* FOLDERS LIST */}
               {library?.data &&
                  library?.data?.folders?.map((folder) => (
                     <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={4} key={folder._id}>
                        <Droppable id={folder._id}>
                           <FolderCard folder={folder} />
                        </Droppable>
                     </Col>
                  ))}

               {/* FILES LIST */}
               {library?.data &&
                  library?.data?.files?.map((file) => (
                     <>
                        <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={4} key={file._id}>
                           <FileCard file={file} />
                        </Col>
                     </>
                  ))}
            </Row>

            <DragOverlay dropAnimation={null}>
               <div
                  style={{
                     display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center',
                     width: '180px',
                     height: '40px',
                     borderRadius: 8,
                     backgroundColor: '#1890ff',
                     color: 'white',
                     dropShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)',
                     fontSize: 16,
                     padding: '0 16px',
                  }}
               >
                  <Flex gap={16} style={{ width: '100%' }}>
                     <i className="fi fi-rr-file" style={{ fontSize: 16 }} />
                     <Text
                        ellipsis
                        style={{
                           color: 'white',
                           fontSize: 16,
                        }}
                     >
                        {activeId}
                     </Text>
                  </Flex>
               </div>
            </DragOverlay>
         </DndContext>
      </>
   );
}
